<template>
  <a-modal title="拜访记录" okText v-model="visible" :width="650" destroyOnClose class="showMessage">
    <template v-if="listData">
      <a-row class="row-content" type="flex" justify="start" align="middle">
        <a-spin :spinning="loading" size="large" style="width:100%;">
          <ul class="data-list">
            <template v-for="(item, index) in listData">
              <li
                class="list"
                :key="index"
                style="borderBottom:1px solid #eeeeee;marginBottom:20px;"
              >
                <div
                  class="titlea"
                  style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;"
                >
                  <span>添加人：{{item.ie_name}}</span>
                  <span>添加时间：{{item.created_at}}</span>
                </div>
                <div style="marginTop:10px; marginBottom:20px;">{{item.content}}</div>
              </li>
            </template>
          </ul>
        </a-spin>
      </a-row>
    </template>
  </a-modal>
</template>
<script>
import Api from "@/api";
export default {
  name: "EditMessage",
  props: {
    callback: {
      type: Function
    }
  },
  created() {},
  mounted() {},
  data() {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      company: "",
      listData: []
    };
  },
  watch: {},
  methods: {
    show(item) {
      this.visible = true;
      console.log(item);
      this.company = item;
      this.$nextTick().then(() => {
        let params = {
          hr_company_id: this.company.id
        };
        console.log(params);
        this.loading = true;
        Api.client.showLook(params).then(res => {
          console.log(res);
          this.listData = res.remarks;
          this.loading = false;
        });
      });
    },
    close() {
      this.visible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.showMessage {
  .ant-modal-title {
    text-align: center;
  }
  .listtitle {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .row-content {
    margin-left: 10px;
    .col {
      width: 50%;
      margin-bottom: 10px;
      .active {
        color: #35b5fe;
      }
    }
    .row {
      width: 100%;
      margin-bottom: 10px;
      .active {
        color: #35b5fe;
      }
    }
  }
  .blue {
    color: #35b5fe;
  }
}
</style>
